import baseRoute from '../baseRoute';

export type * from './viewModel';

type RouteDefinition = `${typeof baseRoute}/jobCodesForInvoices`;

export const ROUTE: RouteDefinition = `${baseRoute}/jobCodesForInvoices`;

export const URL = (): RouteDefinition => `${baseRoute}/jobCodesForInvoices`;
